<template>
    <kt-row style="padding-right: 25px;display: block" v-if="settings">
        <div v-for="(service,index) in all_services" v-bind:key="index">
            <kt-row>
                <kt-col lg="2" md="2" sm="6" xs="12" style="margin-top: 34px">
                    <p>
                        {{ $t('application.services.' + services[index]) }}
                    </p>
                </kt-col>
                <kt-col lg="10" md="10" sm="6" xs="12">
                    <div v-for="(bank, index) in getServiceBanks(service)" v-bind:key="bank">
                        <kt-row>
                            <kt-col lg="2" md="2" sm="6" xs="12">
                                <kt-form-group ref="bank">
                                    <kt-form-label for="bank">
                                        {{ $t('label.bank') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        :value="bankIdStr.get(bank)"
                                        disabled
                                        :id="index"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="10" md="10" sm="6" xs="12">
                                <div  v-for="(provider, key) in getServiceBankProvider(service, bank)" v-bind:key="provider">
                                    <kt-row>
                                        <kt-col  lg="2" md="2" sm="3" xs="12">
                                            <kt-form-group ref="bank">
                                                <kt-form-label for="bank">
                                                    {{ $t('application.provider') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                    :value="providerTypeStr.get(provider)"
                                                    disabled
                                                    :id="index"></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col lg="10" md="10" sm="9" xs="12">
                                            <div>
                                                <kt-row>
                                                    <kt-col lg="2"
                                                            md="2" sm="6" xs="12">
                                                        <h6 style="font-weight: bold;padding-top: 30px">{{
                                                                $t('application.company_wage')
                                                            }}</h6>
                                                    </kt-col>
                                                    <kt-col v-show="Object.values(changeableWageServices).includes(service)" lg="2"
                                                            md="2" sm="6" xs="12">
                                                        <kt-form-group ref="bank">
                                                            <kt-form-label for="company_wage_type">
                                                                {{ $t('label.wage_type') }}
                                                            </kt-form-label>
                                                            <kt-form-select size="5" id="wage_type" class="form-control"
                                                                            :name="service+'_'+bank+'_'+provider+'_company_wage_type'"
                                                                            v-model="settings[service][bank][provider].company_wage_type"
                                                            >
                                                                <option value=""></option>
                                                                <option
                                                                    v-bind:key="index"
                                                                    v-for="(wage, index) in filteredWageTypes(service)"
                                                                    v-bind:value="wage.value"
                                                                    :selected="wage.value"
                                                                >
                                                                    {{ wage.title }}
                                                                </option>
                                                            </kt-form-select>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col lg="3" md="3" sm="6" xs="12"
                                                            v-show="settings[service][bank][provider].company_wage_type == 1 || !Object.values(changeableWageServices).includes(service)">
                                                        <kt-form-group>
                                                            <kt-form-label :for="index">
                                                                {{ $t('application.inquiry_price') }}

                                                            </kt-form-label>
                                                            <kt-form-control dir="ltr" type="number"
                                                                             :name="service+'_'+bank+'_'+provider+'_company_wage'"
                                                                             :id="index"
                                                                             v-model="settings[service][bank][provider].company_wage"
                                                            ></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col lg="2" md="2" sm="6" xs="12"
                                                            v-show="settings[service][bank][provider].company_wage_type == 2">
                                                        <kt-form-group>
                                                            <kt-form-label :for="index">
                                                                {{ $t('application.wage_percent') }}
                                                            </kt-form-label>
                                                            <kt-form-control dir="ltr" type="number"
                                                                             :name="service+'_'+bank+'_'+provider+'_company_wage'"
                                                                             :id="index"
                                                                             v-model="settings[service][bank][provider].company_wage"
                                                            ></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col lg="3" md="3" sm="6" xs="12"
                                                            v-show="settings[service][bank][provider].company_wage_type == 2">
                                                        <kt-form-group>
                                                            <kt-form-label :for="index">
                                                                {{ $t('application.min_wage_amount') }}
                                                            </kt-form-label>
                                                            <kt-form-control dir="ltr" type="number"
                                                                             :id="index"
                                                                             :name="service+'_'+bank+'_'+provider+'_company_min_wage'"
                                                                             v-model="settings[service][bank][provider].company_min_wage"
                                                            ></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col lg="3" md="3" sm="6" xs="12"
                                                            v-show="settings[service][bank][provider].company_wage_type == 2">
                                                        <kt-form-group>
                                                            <kt-form-label :for="index">
                                                                {{ $t('application.max_wage_amount') }}
                                                            </kt-form-label>
                                                            <kt-form-control dir="ltr" type="number"
                                                                             :id="index"
                                                                             :name="service+'_'+bank+'_'+provider+'_company_max_wage'"
                                                                             v-model="settings[service][bank][provider].company_max_wage"
                                                            ></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                </kt-row>
                                                <kt-row>
                                                    <kt-col lg="2" md="2" sm="6" xs="12">
                                                        <h6 style="font-weight: bold;padding-top: 30px">{{
                                                                $t('application.provider_wage')
                                                            }}</h6>
                                                    </kt-col>
                                                    <kt-col v-show="Object.values(changeableWageServices).includes(service)"
                                                            lg="2" md="2" sm="6" xs="12">
                                                        <kt-form-group ref="bank">
                                                            <kt-form-label for="provider_wage_type">
                                                                {{ $t('label.wage_type') }}
                                                            </kt-form-label>
                                                            <kt-form-select size="5" id="wage_type" class="form-control"
                                                                            :name="service+'_'+bank+'_'+provider+'_provider_wage_type'"
                                                                            v-model="settings[service][bank][provider].provider_wage_type"
                                                            >
                                                                <option value=""></option>
                                                                <option
                                                                    v-bind:key="index"
                                                                    v-for="(wage, index) in filteredWageTypes(service)"
                                                                    v-bind:value="wage.value"
                                                                    :selected="wage.value"
                                                                >
                                                                    {{ wage.title }}
                                                                </option>
                                                            </kt-form-select>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col lg="3" md="3" sm="6" xs="12"
                                                            v-show="settings[service][bank][provider].provider_wage_type == 1 || !Object.values(changeableWageServices).includes(service)">
                                                        <kt-form-group>
                                                            <kt-form-label :for="index">
                                                                {{ $t('application.inquiry_price') }}

                                                            </kt-form-label>
                                                            <kt-form-control dir="ltr" type="number"
                                                                             :name="service+'_'+bank+'_'+provider+'_provider_wage'"
                                                                             :id="index"
                                                                             v-model="settings[service][bank][provider].provider_wage"
                                                            ></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col lg="2" md="2" sm="6" xs="12"
                                                            v-show="settings[service][bank][provider].provider_wage_type == 2">
                                                        <kt-form-group>
                                                            <kt-form-label :for="index">
                                                                {{ $t('application.wage_percent') }}
                                                            </kt-form-label>
                                                            <kt-form-control dir="ltr" type="number"
                                                                             :name="service+'_'+bank+'_'+provider+'_provider_wage'"
                                                                             :id="index"
                                                                             v-model="settings[service][bank][provider].provider_wage"
                                                            ></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col lg="3" md="3" sm="6" xs="12"
                                                            v-show="settings[service][bank][provider].provider_wage_type == 2">
                                                        <kt-form-group>
                                                            <kt-form-label :for="index">
                                                                {{ $t('application.min_wage_amount') }}
                                                            </kt-form-label>
                                                            <kt-form-control dir="ltr" type="number"
                                                                             :id="index"
                                                                             :name="service+'_'+bank+'_'+provider+'_provider_min_wage'"
                                                                             v-model="settings[service][bank][provider].provider_min_wage"
                                                            ></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col lg="3" md="3" sm="6" xs="12"
                                                            v-show="settings[service][bank][provider].provider_wage_type == 2">
                                                        <kt-form-group>
                                                            <kt-form-label :for="index">
                                                                {{ $t('application.max_wage_amount') }}
                                                            </kt-form-label>
                                                            <kt-form-control dir="ltr" type="number"
                                                                             :id="index"
                                                                             :name="service+'_'+bank+'_'+provider+'_provider_max_wage'"
                                                                             v-model="settings[service][bank][provider].provider_max_wage"
                                                            ></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                </kt-row>
                                            </div>
                                        </kt-col>
                                    </kt-row>
                                    <hr v-if="key < getServiceBankProvider(service, bank).length -1">
                                </div>
                            </kt-col>
                        </kt-row>
                        <hr v-if="index < getServiceBanks(service).length -1">
                    </div>
                </kt-col>
            </kt-row>
            <hr style="background-color: red">
        </div>
    </kt-row>
</template>

<script>
import {applicationServiceStatus, services, financialServices, providerTypeStr, changeableWageServices} from '@/constants/openBanking'
import {bankIdStr} from '@/constants/bankId'
import {i18n} from '@/plugins/i18n';

export default {
    props: {
        all_services: {
            required: true,
        },
        settings: {
            required: true
        },
        service_bank_providers: {
            required: true
        }
    },
    computed: {
        bankIdStr() {
            return bankIdStr
        },
        filteredWageTypes() {
            return (service) => {
                return this.wage_types.filter(wage_type =>
                    Object.values(this.changeableWageServices).includes(service) || wage_type.value !== 2
                );
            };
        }
    },
    methods: {
        getProviders(service) {
            return Object.keys(this.service_bank_providers[service])
        },
        getServiceBankProvider(service, bank) {
            return this.service_bank_providers[service][bank]
        },
        getServiceBanks(service) {
            return Object.keys(this.service_bank_providers[service])
        },
        serviceHasBank(service) {
            return Object.values(this.financialServices).includes(service)
        }
    },
    data() {
        return {
            applicationServiceStatus,
            services,
            financialServices,
            providerTypeStr,
            changeableWageServices,
            wage_types: [
                {
                    title: i18n.t('gateway.wage_types.fixed'),
                    value: 1
                },
                {
                    title: i18n.t('gateway.wage_types.percent'),
                    value: 2
                },
            ]
        }
    }
}
</script>

<style>

</style>